import { createStore, applyMiddleware } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import thunk from 'redux-thunk';
import logger from 'redux-logger';
import reducers from './reducers';
import { AppStore } from '../interfaces/storeInterfaces';

const middleWare = process.env.NODE_ENV !== 'production' ? [thunk, logger] : [thunk];

const persistConfig = {
    key: 'root',
    storage
};

const persistedReducer = persistReducer(persistConfig, reducers);

const createAppStore = (): AppStore => {
    const store = createStore(persistedReducer, applyMiddleware(...middleWare));
    const persistor = persistStore(store);
    return { store, persistor };
};

export default createAppStore;
